"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_AGGREGATED_ATTRIBUTE_DATA = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PRODUCT_AGGREGATED_ATTRIBUTE_DATA = (0, gql_1.gql)(`
  query ProductAggregatedAttributeValuesData(
    $ids: [ID!], 
    $productTreeId: ID!, 
    $attribute: String,
    $first: Int,
    $productTreeNodeIds: [ID!],
    $after: ID
  ) {
    catalogs(ids: $ids) {
      edges {
        node {
          id
          statistics(productTreeNodeIds: $productTreeNodeIds, productTreeId: $productTreeId) {
            # First part: we get value for cell using attribute and terminalNode
            attributes(attribute: $attribute, first: $first, after: $after) {
              edges {
                node {
                  dimensions {
                    productTreeNode {
                      id
                      title
                    }
                    attribute
                    value
                  }
                  applied
                }
              }
              totalCount
              pageInfo {
                endCursor
                hasNextPage
                hasPreviousPage
                startCursor
              }
            }

            # Second part: we get data for the left columns, attribute values total
            groupedTotals: attributes(attribute: $attribute) {
              groupedTotals {
                applied
                dimensions {
                  attribute
                  value
                }
                total
                unknown
                notApplicable
              }
            }
          }
        }
      }
    }
  }
`);
